export enum LinkTextSize {
  Small = "small",
  Medium = "medium"
}

export const LINK_TEXT_SMALL_FONT = 12;
export const LINK_TEXT_MEDIUM_FONT = 14;
